import { __decorate } from "tslib";
import { Component, Vue, Ref, Prop, Watch } from 'vue-property-decorator';
import { getTaskList, deleteTargetsDetail } from '@blade-sxp/monitor/api/queue/task';
import AuthItem from '@blade/common/components/auth/auth-item.vue';
let default_1 = class default_1 extends Vue {
    multipleTable;
    keyword;
    taskList = [];
    order = 'descending';
    loading = false;
    pageSizes = [10, 20, 30, 40];
    pagination = { page: 1, size: this.pageSizes[0], total: 0 };
    taskRunStatus = '';
    filterStatus = [];
    filterTaskStatus = [];
    pageOrderList = [];
    statusColorMap = new Map([
        [2, { color: '#D9363E', labelKey: 'noEffective' }],
        [1, { color: '#6DD400', labelKey: 'effective' }],
        [3, { color: '#F7B500', labelKey: 'abnormal' }],
    ]);
    initI18n() {
        this.filterTaskStatus = [
            { text: this.$t('effective'), value: 1 },
            { text: this.$t('noEffective'), value: 2 },
            { text: this.$t('abnormal'), value: 3 },
        ];
    }
    formatDeviceName(rowData) {
        const { deviceNames = [] } = rowData;
        return deviceNames.join(',');
    }
    handleFilterChange(filters) {
        if (filters.taskRunStatus) {
            this.taskRunStatus = filters.taskRunStatus[0];
            this.getTaskList();
        }
    }
    handleSizeChange(val) {
        this.pagination.size = val;
        this.getTaskList();
    }
    handleCurrentChange(val) {
        this.pagination.page = val;
        this.getTaskList();
    }
    /**
     *@Description: 排序向后段发送请求
     *@Date: 2020-09-10 18:20:13
     */
    handleSortChange(column) {
        const sortMap = { descending: 'DESC', ascending: 'ASC' };
        const { prop, order } = column;
        this.changeOrderList(prop, sortMap[order]);
        this.getTaskList();
    }
    changeOrderList(orderFiled, orderType) {
        const index = this.pageOrderList.findIndex(data => data.orderFiled === orderFiled);
        if (index === -1) {
            if (orderType)
                this.pageOrderList.push({ orderFiled, orderType });
        }
        else if (!orderType) {
            this.pageOrderList.splice(index, 1);
        }
        else {
            this.pageOrderList[index].orderType = orderType;
        }
    }
    formatStatus(row, column, cellValue) {
        const status = this.statusColorMap.get(cellValue);
        const { color = '#F7B500', labelKey = 'abnormal' } = status || {};
        return (<div style="display: flex; align-items: center">
        <div class="dot" style={`background:${color}`}/>
        {this.$t(labelKey)}
      </div>);
    }
    getTaskList() {
        this.loading = true;
        const reqParam = {
            page: this.pagination.page,
            size: this.pagination.size,
            keyword: this.keyword,
            pageOrderList: this.pageOrderList,
            taskRunStatus: this.taskRunStatus,
        };
        getTaskList({ ...reqParam })
            .then(re => {
            this.loading = false;
            this.taskList = re.data.data.list;
            // const total = re.data.data.totalSize;
            this.pagination.total = re.data.data.totalSize;
        })
            .catch(error => {
            this.loading = false;
            this.$message.error(error.message);
        });
    }
    /**
     *@Description: 删除任务
     *@Date: 2020-09-17 10:08:01
     */
    handleDelete(sid) {
        let confirm = `${this.$t('common.confirm')}`;
        let deviceConfirmDelete = `${this.$t('device.confirmDelete')}`;
        this.$alert(deviceConfirmDelete, {
            confirmButtonText: confirm,
            callback: action => {
                if (action === 'confirm') {
                    deleteTargetsDetail(sid).then((res) => {
                        this.$message({
                            message: res.data.message,
                            type: 'success',
                        });
                        this.getTaskList();
                    });
                }
            },
        });
    }
    /**
     *@Description: 编辑任务
     *@Date: 2020-09-17 10:24:22
     */
    handleEdit(id) {
        this.$router.push(`/application/queue/taskManagement/editQueueControl/${id}`);
    }
    mounted() {
        this.getTaskList();
        this.initI18n();
    }
};
__decorate([
    Ref()
], default_1.prototype, "multipleTable", void 0);
__decorate([
    Prop()
], default_1.prototype, "keyword", void 0);
__decorate([
    Watch('$i18n.locale')
], default_1.prototype, "initI18n", null);
default_1 = __decorate([
    Component({
        name: 'TaskFaceControl',
        components: { AuthItem },
        i18n: {
            messages: {
                'en-us': {
                    taskType: 'Task Type',
                    queueStatistic: 'Queued People Counting',
                    noEffective: 'No Effective',
                    abnormal: 'Abnormal',
                    effective: 'Effective',
                },
                zh: {
                    taskType: '任务类型',
                    queueStatistic: '排队区域统计',
                    noEffective: '未生效',
                    abnormal: '异常',
                    effective: '已生效',
                },
            },
        },
    })
], default_1);
export default default_1;
